export default __webpack_public_path__ + "assets/images/edec61113daedec123a41be1b68efe29.png";